import PageSeo from "@/components/PageSeo";
import CtaBannerSection from "@/components/sections/CtaBannerSection";
import HeroSection from "@/components/sections/HeroSection";
import VideoShowcaseSection from "@/components/sections/VideoShowcaseSection";
import { youtubePageContent } from "@/content/pages/youtubePage";

export default function YoutubePage() {
  return (
    <div className="pt-16 md:pt-20">
      <PageSeo seo={youtubePageContent.seo} />
      <HeroSection content={youtubePageContent.hero} dataTestId="youtube-hero" />
      <VideoShowcaseSection content={youtubePageContent.videoSection} dataTestId="youtube-showcase" className="bg-muted/50" />
      <CtaBannerSection content={youtubePageContent.finalCta} dataTestId="youtube-cta" />
    </div>
  );
}
